import React from 'react';
import { Stack, Text } from 'braid-design-system';

interface Props {
  advertiserName: string | null;
  userFirstName: string | null;
  accountNumber: number;
}

function ActiveAccount({
  userFirstName,
  advertiserName,
  accountNumber,
}: Props) {
  return (
    <Stack space="small">
      <Text weight="strong">{userFirstName} </Text>
      <Text>
        {advertiserName} ({accountNumber})
      </Text>
    </Stack>
  );
}

export default ActiveAccount;
